export default __webpack_public_path__ + "static/media/img02.117b7c82.png";